import { validationOneTwo } from '../modules/signup/ValidationOneTwo'

export const toSignupLogin = {
    state: {
        showSignupLogin: null
    },
    actions: {
        toSignupLogin({ commit }, show) {
            commit('TO_SIGNUP_TO_LOGIN', show)
        }
    },
    mutations: {
        TO_SIGNUP_TO_LOGIN(state, show) {
            state.showSignupLogin = show
            state.showCreateAccountComp = false
            validationOneTwo.state.accntName = ''
        }
    },
    getters: {
        hideLoginSignup(state) {
            return state.showSignupLogin
        }
    }
}
